import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const articleLinks = [
    { label: 'YOYBUY Spreadsheet', slug: 'yoybuy-spreadsheet-guide' },
    { label: 'Kakobuy Spreadsheet', slug: 'kakobuy-spreadsheet-guide' },
    { label: 'YOYBUY vs Kakobuy vs Superbuy', slug: 'yoybuy-vs-kakobuy-vs-superbuy' },
  ];

  return (
    <footer className="w-full bg-background-100 pt-16 md:pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          <div>
            <h4 className="font-label font-semibold text-foreground-900 text-sm mb-4 whitespace-nowrap">
              {t('footerCategories')}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 font-body hover:text-accent-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.nameRu}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label font-semibold text-foreground-900 text-sm mb-4 whitespace-nowrap">
              {t('footerArticles')}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2">
              {articleLinks.map((link) => (
                <li key={link.slug}>
                  <Link
                    to={`/article/${link.slug}`}
                    className="text-sm text-foreground-600 font-body hover:text-accent-500 transition-colors duration-200 text-left cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label font-semibold text-foreground-900 text-sm mb-4 whitespace-nowrap">
              {t('footerAbout')}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-foreground-600 font-body hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                  {t('siteName')}
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 font-body hover:text-accent-500 transition-colors duration-200 whitespace-nowrap"
                >
                  kaspreadsheet.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label font-semibold text-foreground-900 text-sm mb-4 whitespace-nowrap">
              {t('footerHelp')}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-foreground-600 font-body hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                  FAQ
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 font-body hover:text-accent-500 transition-colors duration-200 whitespace-nowrap"
                >
                  Поддержка
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <p className="font-heading text-2xl text-foreground-900 font-semibold leading-tight">
                yoybuy.hair
              </p>
              <p className="font-heading text-2xl text-foreground-400 font-light leading-tight">
                sheet
              </p>
              <div className="w-12 h-px bg-background-300 my-2"></div>
              <p className="text-xs text-foreground-500 font-body">
                {t('footerCopyright')}
              </p>
            </div>

            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-accent-100 hover:text-accent-500 transition-colors duration-200"
                aria-label="Kaspreadsheet"
              >
                <i className="ri-external-link-line text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-accent-100 hover:text-accent-500 transition-colors duration-200"
                aria-label="Share"
              >
                <i className="ri-share-line text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-accent-100 hover:text-accent-500 transition-colors duration-200"
                aria-label="Link"
              >
                <i className="ri-link-m text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-accent-100 hover:text-accent-500 transition-colors duration-200"
                aria-label="More"
              >
                <i className="ri-more-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}